import React from 'react';
import { Navigate } from 'react-router-dom';

import { CONFIG } from '../../global-config';

export const AuthRedirectBehavior: React.FC = () => (
  <Navigate to={CONFIG.auth.redirectPath} replace />
);

export const AuthLogoutRedirectBehavior: React.FC = () => (
  // May not always be the same as auth-redirect and
  // so this is kept as a separate component.
  // Future logout behavior is still TBD.
  <Navigate to={CONFIG.auth.redirectPath} replace />
);
